import * as React from "react"

import { cn } from "../../lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-[8px] border border-input bg-white px-3 py-2 text-vt-texte font-medium text-foreground placeholder:text-t2 focus-visible:border-brand focus-visible:outline-none disabled:cursor-not-allowed",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
